import Cookies from 'universal-cookie';
import { COOKIE_KEY_VENDOR_CONFIG } from '../constants.mjs';

function setVendorConfigCookie(config) {
  document.cookie = bakeVendorConfigCookie({
    key: COOKIE_KEY_VENDOR_CONFIG,
    value: {
      userId: config.userId,
      deviceId: config.deviceId,
      lastSessionId: config.sessionId
    },
    options: {
      expiresTime: new Date(Date.now() + 1e3 * 60 * 60 * 24 * 365),
      path: "/"
    }
  });
}
function deleteVendorConfigCookie() {
  const universalCookies = new Cookies();
  universalCookies.remove(COOKIE_KEY_VENDOR_CONFIG, { path: "/" });
}
function getVendorConfig(cookies) {
  const universalCookies = new Cookies(cookies);
  const configFromCookie = universalCookies.get(COOKIE_KEY_VENDOR_CONFIG);
  try {
    if (isServerSideVendorConfig(configFromCookie)) {
      return configFromCookie;
    }
    throw new Error("vendor config \uAC12\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.");
  } catch {
    return {
      userId: void 0,
      deviceId: void 0,
      lastSessionId: void 0
    };
  }
}
function bakeVendorConfigCookie({
  key,
  value,
  options
}) {
  const assembler = [`${key}=${JSON.stringify(value)}`];
  if (options?.expiresTime) {
    assembler.push(`expires=${options.expiresTime.toUTCString()}`);
  }
  if (options?.path) {
    assembler.push(`path=${options.path}`);
  }
  return assembler.join(";");
}
function isServerSideVendorConfig(config) {
  return typeof config === "object" && "userId" in config && typeof config.userId === "string" && "deviceId" in config && typeof config.deviceId === "string" && "lastSessionId" in config && typeof config.lastSessionId === "number";
}

export { bakeVendorConfigCookie, deleteVendorConfigCookie, getVendorConfig, setVendorConfigCookie };
//# sourceMappingURL=config.mjs.map
